import { OwnerContractLeaseTypeOption } from '@/graphql/generated';
import { ownerContractLeaseTypeMapper } from '@/helpers/ownerContractLeaseTypeMapper';
import textsData from '@/textData/CreateContractsTexts.json';
import { useCreateOwnerContractContext, useUserLanguage } from '@/customHooks';

const LEASE_TYPE_OPTIONS: OwnerContractLeaseTypeOption[] = [
  OwnerContractLeaseTypeOption.AssuredPayment,
  OwnerContractLeaseTypeOption.LeaseSublet,
  OwnerContractLeaseTypeOption.OccupationManagment,
];

export const SelectOwnerContractLeaseTypeStep = () => {
  const { state, setLeaseType } = useCreateOwnerContractContext();
  const userLanguage = useUserLanguage();

  const rootTexts = userLanguage === 'es' ? textsData.es : textsData.en;
  const texts = rootTexts.ownerContract.selectLeaseType;

  const currentLeaseType = state.ownerContractLeaseTypeOption as OwnerContractLeaseTypeOption | null;

  const handleChange = (type: OwnerContractLeaseTypeOption) => {
    setLeaseType(type);
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-3xl">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col gap-6">
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-2">{texts.title}</h2>
            <p className="text-sm text-gray-500">{texts.helper}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {LEASE_TYPE_OPTIONS.map((type) => (
              <button
                key={type}
                type="button"
                onClick={() => handleChange(type)}
                className={`flex flex-col items-center justify-center p-6 rounded-xl border-2 transition-all duration-200 text-center gap-3 ${
                  currentLeaseType === type
                    ? 'border-(--color-primary) bg-(--color-primary-50) text-(--color-primary)'
                    : 'border-gray-100 bg-white hover:border-gray-200 text-gray-600'
                }`}
              >
                <span className="font-semibold text-sm">
                  {ownerContractLeaseTypeMapper(type, userLanguage)}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
